// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3675":"26047bb7998f2c31","5269":"71695a0aaba6382f","9484":"c2e02cbcae6293ac"}[chunkId] + ".css";
};